import React, {Component} from 'react'
import './postTheAmoun.css'
import {Col, Row} from "antd";
import QuantityCard from "./QuantityCard";
import echarts from "echarts/lib/echarts";
// 引入柱状图（这里放你需要使用的echarts类型 很重要）
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import {getPostMount, getYearPostGraph} from "../actions";


class PostTheAmoun extends Component {


    constructor(props) {
        super(props);
        this.state = {
            yearPostCount: 0,
            weekPostCount: 0,
            dayPostCount: 0,
            xcolumn: [],
            ynumber: []
        }
        this.resize = this.resize.bind(this);
    }

    state = {
        width: 0,
        myChart: null
    }

    screenChange() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        console.info("componentWillUnmount");
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.state.myChart.resize();
    }

    updateYearPostCount(totalData) {
        this.setState({
            yearPostCount: totalData.year,
            weekPostCount: totalData.week,
            dayPostCount: totalData.day
        })
    }

    updateYearPostGraph(dayPostCount) {
        let tilte = [];
        let numbers = [];
        dayPostCount.map((el) => {
            tilte.push(el.time);
            numbers.push(el.count);
        });
        this.setState({xcolumn: tilte, ynumber: numbers})
    }

    componentDidMount() {
        this.screenChange();
        // 基于准备好的dom，初始化echarts实例
        this.setState({
            myChart: echarts.init(document.getElementById('main'))
        })

        //获取访问量（累计，周，日）
        getPostMount("year", this.updateYearPostCount.bind(this));

        //获取年发布量条形图
        getYearPostGraph(this.updateYearPostGraph.bind(this));
        setTimeout(() => this.resize(), 1)

    }

    render() {
        // 绘制图表
        if (this.state.myChart) {
            this.state.myChart.setOption({
                backgroundColor: '#F5F8FD',
                height: 240,

                color: ['#54A2EC'],
                title: {
                    text: '近一年发文量',
                    left: 28,
                    top: 23,
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Microsoft YaHei'
                    }
                },
                tooltip: {},
                xAxis: {
                    axisLabel:{interval:0, rotate:45,margin:10},
                    axisTick: {show: false},
                    data: this.state.xcolumn
                },
                grid: {
                    left: '35',
                    right: '35',
                    bottom: '0',
                    containLabel: true
                },
                yAxis: {
                    axisTick: {show: false},
                },
                series: [{
                    name: '直接访问',
                    type: 'bar',
                    barCategoryGap: '10%',
                    barGap: '10px',//柱
                    barWidth: '14px',
                    data: this.state.ynumber
                }],
            });
        }

        return <div className='postTheAmoun'>
            <Row>
                <Col span={5} xs={5} md={5} xxl={5}>
                    <div className="postTheAmounleft ">
                        <div className='cardTitle'>发文量</div>
                        <AccessCard title={'近一年发文量'} number={this.state.yearPostCount} image={'url(images/left01.png)'}
                                    color={'#FE5B00'}></AccessCard>
                        <AccessCard title={'本周发文量'} number={this.state.weekPostCount} image={'url(images/left02.png)'}
                                    color={'#393F45'}></AccessCard>
                        <AccessCard title={'今日发文量'} number={this.state.dayPostCount} image={'url(images/left03.png)'}
                                    color={'#393F45'}></AccessCard>
                    </div>
                </Col>
                <Col span={19} xs={19} md={19} xxl={19}>
                    <div>
                        <div className="postTheAmounGraph" style={{width: "100%",maxWidth:712}} id='main'>
                        </div>
                    </div>
                </Col>

            </Row>


        </div>
    }
}

class AccessCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: props.image,
            color: props.color
        }
    }

    render() {
        let stylet = {
            backgroundImage: this.state.image,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain"
        }

        let numberStyle = {
            color: this.state.color
        }

        return <div className='accessCard'>
            <Row>
                <Col span={8} xs={8} md={8} xxl={8}>
                    <div className='accessImage access' style={stylet}></div>
                </Col>
                <Col span={16} xs={16} md={16} xxl={16}>
                    <div className="titleNumber">
                        <div className='title'>{this.props.title}</div>
                        <div className='number' style={numberStyle}>{this.props.number}</div>
                    </div>
                </Col>
            </Row>
        </div>
    }
}

export default PostTheAmoun;
